import src from "IMAGE";
export default { src, width: 528, height: 320, blurWidth: 0, blurHeight: 0};
